import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, OnDestroy } from '@angular/core';

@Directive({
    selector: '[fiMeasureLabel]',
    standalone: false,
})
export class FiMeasureLabelDirective implements AfterViewInit, OnDestroy {
    @Output() labelWidthChange = new EventEmitter<number>();

    private observer: ResizeObserver | null = null;

    constructor(private elementRef: ElementRef) {}

    public ngAfterViewInit(): void {
        this.observer = new ResizeObserver(() => {
            this.measureAndEmit();
        });
        this.observer.observe(this.elementRef.nativeElement);
        this.measureAndEmit();
    }

    private measureAndEmit(): void {
        const width = this.elementRef.nativeElement.offsetWidth;
        this.labelWidthChange.emit(width);
    }

    public ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
